(() => {
  const MENU_SELECTOR = '.mega-menu-v5-square';
  const ITEM_SELECTOR = '.mega-menu-v5-square__item[data-mega-subcategory]';
  const MOBILE_QUERY = '(max-width: 767px)';

  function isMobile() {
    return window.matchMedia(MOBILE_QUERY).matches;
  }

  function getSubcategoryMeta(menu, label) {
    const wanted = (label || '').trim().toLowerCase();
    if (!wanted) return { url: '', image: '' };
    for (let i = 1; i <= 10; i += 1) {
      const name = (menu.getAttribute(`data-subcategory-name-${i}`) || '').trim().toLowerCase();
      if (name && name === wanted) {
        return {
          url: (menu.getAttribute(`data-subcategory-url-${i}`) || '').trim(),
          image: (menu.getAttribute(`data-subcategory-image-${i}`) || '').trim()
        };
      }
    }
    return { url: '', image: '' };
  }

  function layoutPanels(menu) {
    const nav = menu.querySelector('.mega-menu-v5-square__subcategory-nav');
    const content = menu.querySelector('.mega-menu-v5-square__subcategory-content');
    if (!nav || !content) return;

    const triggers = Array.from(nav.querySelectorAll('.mega-menu-v5-square__subcategory-trigger'));
    const panels = Array.from(menu.querySelectorAll('.mega-menu-v5-square__subcategory-panel'));

    if (isMobile()) {
      triggers.forEach((trigger, index) => {
        const panel = panels.find((candidate) => candidate.dataset.bddGroupIndex === String(index));
        if (panel && trigger.nextElementSibling !== panel) trigger.after(panel);
      });
    } else {
      panels
        .sort((a, b) => Number(a.dataset.bddGroupIndex) - Number(b.dataset.bddGroupIndex))
        .forEach((panel) => content.appendChild(panel));
    }
  }

  function setActive(menu, index, options = {}) {
    const { toggleMobile = false, focusPanel = false } = options;
    const triggers = Array.from(menu.querySelectorAll('.mega-menu-v5-square__subcategory-trigger'));
    const panels = Array.from(menu.querySelectorAll('.mega-menu-v5-square__subcategory-panel'));
    const selected = triggers[index];
    const shouldClose = isMobile() && toggleMobile && selected?.classList.contains('is-active');

    triggers.forEach((trigger, i) => {
      const active = !shouldClose && i === index;
      trigger.classList.toggle('is-active', active);
      trigger.setAttribute('aria-expanded', active ? 'true' : 'false');
    });

    panels.forEach((panel) => {
      const active = !shouldClose && Number(panel.dataset.bddGroupIndex) === index;
      panel.classList.toggle('is-active', active);
      panel.hidden = !active;
      if (active) {
        playMegaVideos(panel);
        startProductAutoplay(panel.querySelector('.bdd-mega-products'));
      }
      if (active && focusPanel) panel.focus({ preventScroll: true });
    });

    menu.dataset.bddActiveGroup = shouldClose ? '' : String(index);
  }

  function playMegaVideos(root) {
    root.querySelectorAll('video').forEach((video) => {
      video.muted = true;
      video.playsInline = true;
      const promise = video.play();
      if (promise?.catch) promise.catch(() => {});
    });
  }

  function stopProductAutoplay(carousel) {
    if (!carousel) return;
    if (carousel._bddAutoplayFrame) window.cancelAnimationFrame(carousel._bddAutoplayFrame);
    carousel._bddAutoplayFrame = null;
    carousel._bddAutoplayLast = null;
  }

  function prepareContinuousProductLoop(viewport) {
    const track = viewport?.querySelector('[data-bdd-mega-products-track]');
    if (!track) return;
    track.querySelectorAll('[data-bdd-loop-clone]').forEach((clone) => clone.remove());
    const originals = Array.from(track.querySelectorAll('.bdd-mega-product-card'));
    if (originals.length < 2) { track._bddLoopDistance = 0; return; }
    originals.forEach((card) => {
      const clone = card.cloneNode(true);
      clone.dataset.bddLoopClone = 'true';
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    });
    const firstClone = track.querySelector('[data-bdd-loop-clone]');
    track._bddLoopDistance = firstClone ? firstClone.offsetLeft - originals[0].offsetLeft : 0;
    track._bddX = 0;
    track.style.transform = 'translate3d(0,0,0)';
  }

  function startProductAutoplay(carousel) {
    if (!carousel || isMobile()) return;
    stopProductAutoplay(carousel);
    const viewport = carousel.querySelector('.bdd-mega-products__viewport');
    const track = viewport?.querySelector('[data-bdd-mega-products-track]');
    if (!viewport || !track) return;
    if (!track._bddLoopDistance) prepareContinuousProductLoop(viewport);
    if (!track._bddLoopDistance) return;

    const menu = carousel.closest(MENU_SELECTOR);
    const speedSetting = Math.max(2, Math.min(10, Number(menu?.dataset.bddCarouselDelay) / 1000 || 4));
    const pixelsPerSecond = 18 * (5 / speedSetting);

    const normalize = () => {
      const loop = track._bddLoopDistance || 0;
      if (!loop) return;
      while (track._bddX <= -loop) track._bddX += loop;
      while (track._bddX > 0) track._bddX -= loop;
    };
    carousel._bddRenderTrack = () => {
      normalize();
      track.style.transform = `translate3d(${track._bddX}px,0,0)`;
    };

    const tick = (time) => {
      if (!carousel.isConnected) return;
      if (carousel.closest('[hidden]')) {
        carousel._bddAutoplayLast = time;
        carousel._bddAutoplayFrame = requestAnimationFrame(tick);
        return;
      }
      if (carousel._bddAutoplayLast == null) carousel._bddAutoplayLast = time;
      const elapsed = Math.min(50, time - carousel._bddAutoplayLast);
      carousel._bddAutoplayLast = time;
      if (!carousel._bddHoverPaused && !carousel._bddDragging && !document.hidden) {
        track._bddX -= pixelsPerSecond * (elapsed / 1000);
        carousel._bddRenderTrack();
      }
      carousel._bddAutoplayFrame = requestAnimationFrame(tick);
    };
    carousel._bddAutoplayFrame = requestAnimationFrame(tick);
  }

  function updateProductCarousel(panel, item) {
    const carousel = panel?.querySelector('.bdd-mega-products');
    const template = item?.querySelector('.bdd-mega-products-template');
    const viewport = carousel?.querySelector('.bdd-mega-products__viewport');
    if (!carousel || !template || !viewport) return;

    panel.querySelectorAll('.mega-menu-v5-square__item').forEach((candidate) => {
      candidate.classList.toggle('is-product-active', candidate === item);
    });
    const shopAll = carousel.querySelector('.bdd-mega-products__shop-all');
    if (shopAll) shopAll.href = item.href;

    stopProductAutoplay(carousel);
    viewport.replaceChildren(template.content.cloneNode(true));
    prepareContinuousProductLoop(viewport);
    const activeTrack = viewport.querySelector('[data-bdd-mega-products-track]');
    if (activeTrack) { activeTrack._bddX = 0; activeTrack.style.transform = 'translate3d(0,0,0)'; }
    carousel.hidden = false;
    playMegaVideos(viewport);
    startProductAutoplay(carousel);
  }

  function buildProductCarousel(panel, items) {
    const carousel = document.createElement('div');
    carousel.className = 'bdd-mega-products';
    carousel.hidden = true;

    const viewport = document.createElement('div');
    viewport.className = 'bdd-mega-products__viewport';
    viewport.setAttribute('aria-label', 'Products');

    const controls = document.createElement('div');
    controls.className = 'bdd-mega-products__controls';
    const prev = document.createElement('button');
    const next = document.createElement('button');
    prev.type = next.type = 'button';
    prev.className = 'bdd-mega-products__arrow bdd-mega-products__arrow--prev';
    next.className = 'bdd-mega-products__arrow bdd-mega-products__arrow--next';
    prev.setAttribute('aria-label', 'Previous products');
    next.setAttribute('aria-label', 'Next products');
    prev.textContent = '‹';
    next.textContent = '›';
    controls.append(prev, next);

    const footer = document.createElement('div');
    footer.className = 'bdd-mega-products__footer';
    const shopAll = document.createElement('a');
    shopAll.className = 'bdd-mega-products__shop-all';
    shopAll.textContent = 'Shop all';
    footer.append(shopAll, controls);

    carousel.append(viewport, footer);

    carousel.addEventListener('mouseenter', () => { carousel._bddHoverPaused = true; });
    carousel.addEventListener('mouseleave', () => {
      carousel._bddHoverPaused = false;
      carousel._bddDragging = false;
      carousel._bddAutoplayLast = performance.now();
    });

    let pointerId = null, pointerStartX = 0, pointerStartY = 0, pointerTrackStart = 0;
    let pointerMoved = false, horizontalGesture = false;

    viewport.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      const track = viewport.querySelector('[data-bdd-mega-products-track]');
      if (!track) return;
      pointerId = event.pointerId;
      pointerStartX = event.clientX; pointerStartY = event.clientY;
      pointerTrackStart = track._bddX || 0;
      pointerMoved = false; horizontalGesture = false;
      carousel._bddDragging = true;
    }, true);

    viewport.addEventListener('pointermove', (event) => {
      if (!carousel._bddDragging || event.pointerId !== pointerId) return;
      const track = viewport.querySelector('[data-bdd-mega-products-track]');
      if (!track) return;
      const dx = event.clientX - pointerStartX, dy = event.clientY - pointerStartY;
      if (!horizontalGesture && (Math.abs(dx) > 4 || Math.abs(dy) > 4)) horizontalGesture = Math.abs(dx) > Math.abs(dy);
      if (!horizontalGesture) return;
      if (!pointerMoved) {
        try { viewport.setPointerCapture(pointerId); } catch (_) {}
      }
      if (event.cancelable) event.preventDefault();
      if (Math.abs(dx) > 4) pointerMoved = true;
      track._bddX = pointerTrackStart + dx;
      carousel._bddRenderTrack?.();
    }, { capture: true, passive: false });

    const finishPointer = (event) => {
      if (!carousel._bddDragging || (event.pointerId != null && event.pointerId !== pointerId)) return;
      carousel._bddDragging = false;
      try { viewport.releasePointerCapture(pointerId); } catch (_) {}
      pointerId = null; carousel._bddAutoplayLast = performance.now();
    };
    viewport.addEventListener('pointerup', finishPointer, true);
    viewport.addEventListener('pointercancel', finishPointer, true);

    viewport.addEventListener('wheel', (event) => {
      const horizontal = Math.abs(event.deltaX) > Math.abs(event.deltaY);
      const shifted = event.shiftKey && Math.abs(event.deltaY) > 0;
      if (!horizontal && !shifted) return;
      const track = viewport.querySelector('[data-bdd-mega-products-track]');
      if (!track) return;
      if (event.cancelable) event.preventDefault();
      track._bddX = (track._bddX || 0) - (horizontal ? event.deltaX : event.deltaY);
      carousel._bddRenderTrack?.();
      carousel._bddAutoplayLast = performance.now();
    }, { passive: false });

    viewport.addEventListener('dragstart', (event) => event.preventDefault(), true);
    viewport.addEventListener('click', (event) => {
      if (!pointerMoved) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      pointerMoved = false;
    }, true);

    // Swatches are controls, not carousel drags. Update the card media/link in place.
    viewport.addEventListener('click', (event) => {
      const swatch = event.target.closest('[data-bdd-swatch]');
      if (!swatch) return;
      event.preventDefault();
      event.stopPropagation();
      const card = swatch.closest('.bdd-mega-product-card');
      if (!card) return;
      card.querySelectorAll('[data-bdd-swatch]').forEach((button) => button.classList.toggle('is-active', button === swatch));
      const image = card.querySelector('.bdd-mega-product-card__image');
      if (image && swatch.dataset.imageSrc) {
        image.src = swatch.dataset.imageSrc;
        image.removeAttribute('srcset');
      }
      if (swatch.dataset.variantUrl) {
        card.dataset.productUrl = swatch.dataset.variantUrl;
        card.querySelectorAll('a[href]').forEach((link) => { link.href = swatch.dataset.variantUrl; });
      }
      if (swatch.dataset.variantId) card.dataset.variantId = swatch.dataset.variantId;
    });

    viewport.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-bdd-add-to-cart]');
      if (!button) return;
      event.preventDefault();
      event.stopPropagation();
      const card = button.closest('.bdd-mega-product-card');
      const id = Number(card?.dataset.variantId);
      if (!id || button.disabled) return;

      const original = button.textContent;
      button.disabled = true;
      button.textContent = 'Adding…';
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id, quantity: 1 })
        });
        if (!response.ok) throw new Error('Cart add failed');
        button.textContent = 'Added';
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        setTimeout(() => { button.textContent = original; button.disabled = false; }, 1200);
      } catch (_) {
        button.textContent = 'Try again';
        setTimeout(() => { button.textContent = original; button.disabled = false; }, 1400);
      }
    });

    const move = (direction) => {
      const track = viewport.querySelector('[data-bdd-mega-products-track]');
      const card = viewport.querySelector('.bdd-mega-product-card');
      if (!track || !card) return;
      const gap = parseFloat(getComputedStyle(track).gap) || 16;
      track._bddX = (track._bddX || 0) - direction * (card.getBoundingClientRect().width + gap);
      carousel._bddRenderTrack?.();
      carousel._bddAutoplayLast = performance.now();
    };
    prev.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));

    panel.appendChild(carousel);
    const collectionItems = items.filter((item) => item.querySelector('.bdd-mega-products-template'));
    collectionItems.forEach((item) => {
      item.addEventListener('mouseenter', () => {
        if (!isMobile()) updateProductCarousel(panel, item);
      });
      item.addEventListener('focus', () => {
        if (!isMobile()) updateProductCarousel(panel, item);
      });
    });
    if (collectionItems[0] && !isMobile()) updateProductCarousel(panel, collectionItems[0]);
  }

  function buildGroup(menu, label, items, index) {
    const groupMeta = getSubcategoryMeta(menu, label);
    const trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'mega-menu-v5-square__subcategory-trigger';
    trigger.dataset.bddGroupIndex = String(index);
    trigger.setAttribute('aria-expanded', 'false');
    trigger.setAttribute('aria-controls', `${menu.dataset.bddMenuId}-panel-${index}`);

    const thumb = document.createElement('span');
    thumb.className = 'mega-menu-v5-square__subcategory-thumb';
    if (groupMeta.image) {
      const image = document.createElement('img');
      image.src = groupMeta.image;
      image.alt = '';
      image.loading = 'lazy';
      thumb.appendChild(image);
    } else {
      const firstImage = items[0]?.querySelector('.mega-menu-v5-square__image');
      if (firstImage) thumb.appendChild(firstImage.cloneNode(true));
    }

    const text = document.createElement('span');
    text.className = 'mega-menu-v5-square__subcategory-name';
    text.textContent = label;

    const arrow = document.createElement('span');
    arrow.className = 'mega-menu-v5-square__subcategory-arrow';
    arrow.setAttribute('aria-hidden', 'true');
    arrow.textContent = '›';
    trigger.append(thumb, text, arrow);

    const panel = document.createElement('section');
    panel.className = 'mega-menu-v5-square__subcategory-panel';
    panel.id = `${menu.dataset.bddMenuId}-panel-${index}`;
    panel.dataset.bddGroupIndex = String(index);
    panel.tabIndex = -1;
    panel.hidden = true;

    const heading = document.createElement('div');
    heading.className = 'mega-menu-v5-square__panel-heading';
    const title = document.createElement('span');
    title.className = 'mega-menu-v5-square__panel-title';
    title.textContent = label;
    heading.appendChild(title);
    if (groupMeta.url) {
      const link = document.createElement('a');
      link.className = 'mega-menu-v5-square__panel-link';
      link.href = groupMeta.url;
      link.textContent = 'Shop all';
      heading.appendChild(link);
    }

    const list = document.createElement('div');
    list.className = 'mega-menu-v5-square__group-items';
    items.forEach((item) => list.appendChild(item));
    panel.append(heading, list);
    buildProductCarousel(panel, items);
    return { trigger, panel };
  }

  function enhanceMenu(menu) {
    if (!menu || menu.dataset.bddGrouped === 'true') return;
    const items = Array.from(menu.querySelectorAll(ITEM_SELECTOR)).filter((item) => item.closest(MENU_SELECTOR) === menu);
    if (!items.length || !items.some((item) => (item.dataset.megaSubcategory || '').trim())) return;

    const groups = new Map();
    items.forEach((item) => {
      const label = (item.dataset.megaSubcategory || '').trim() || 'Other';
      if (!groups.has(label)) groups.set(label, []);
      groups.get(label).push(item);
    });

    menu.dataset.bddMenuId = menu.dataset.bddMenuId || `bdd-mega-${Math.random().toString(36).slice(2, 9)}`;
    const shell = document.createElement('div');
    shell.className = 'mega-menu-v5-square__browser';
    const nav = document.createElement('div');
    nav.className = 'mega-menu-v5-square__subcategory-nav';
    nav.setAttribute('role', 'navigation');
    nav.setAttribute('aria-label', 'Subcategories');
    const content = document.createElement('div');
    content.className = 'mega-menu-v5-square__subcategory-content';

    Array.from(groups.entries()).forEach(([label, groupItems], index) => {
      const { trigger, panel } = buildGroup(menu, label, groupItems, index);
      trigger.addEventListener('click', () => setActive(menu, index, { toggleMobile: true }));
      trigger.addEventListener('mouseenter', () => {
        if (window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 768px)').matches) setActive(menu, index);
      });
      trigger.addEventListener('focus', () => {
        if (!isMobile()) setActive(menu, index);
      });
      nav.appendChild(trigger);
      content.appendChild(panel);
    });

    shell.append(nav, content);
    menu.replaceChildren(shell);
    menu.classList.add('mega-menu-v5-square--grouped', 'mega-menu-v5-square--browser');
    menu.dataset.bddGrouped = 'true';
    layoutPanels(menu);

    if (isMobile()) {
      // Mobile starts clean: subcategories are full-width accordion buttons.
      menu.querySelectorAll('.mega-menu-v5-square__subcategory-panel').forEach((panel) => { panel.hidden = true; });
    } else {
      setActive(menu, 0);
    }
  }

  function scan(root = document) {
    if (root.nodeType !== 1 && root !== document) return;
    if (root.matches?.(MENU_SELECTOR)) enhanceMenu(root);
    root.querySelectorAll?.(MENU_SELECTOR).forEach(enhanceMenu);
  }

  function relayoutAll() {
    document.querySelectorAll('.mega-menu-v5-square--browser').forEach((menu) => {
      layoutPanels(menu);
      if (!isMobile() && menu.dataset.bddActiveGroup === '') setActive(menu, 0);
    });
  }

  function boot() {
    scan(document);
    const media = window.matchMedia(MOBILE_QUERY);
    if (media.addEventListener) media.addEventListener('change', relayoutAll);
    else media.addListener(relayoutAll);

    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) scan(node);
      }));
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
